import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';
import useGetPageSection from 'app/hooks/useGetPageSection';
import { StarterLogo, EnterpriseLogo } from 'app/components/Icons';
import { licenseGroupPlanDesignCheck } from 'app/utils/tenant-plan';
import { StringParam, useQueryParam } from 'use-query-params';

const useStyles = makeStyles((theme) => ({
	logo: {
		color: theme.palette.text.primary,
		marginLeft: '0.5rem',
		marginRight: '1.5rem',
		height: 43,
		width: 'auto',
		maxWidth: 'unset',
	},
}));

type Props = {
	link?: boolean;
	classes?: {
		root?: string;
		logo?: string;
	};
};
const Logo = ({ link = false, classes: classesProp = {} }: Props) => {
	const classes = useStyles();

	const pageSection = useGetPageSection();

	const [experience] = useQueryParam('experience', StringParam);

	const tierCheck = (tier: 'stc' | 'stratus') => {
		let bool = licenseGroupPlanDesignCheck(tier);
		if (pageSection.mfpLogin) {
			if (experience) {
				bool = experience === tier;
			}
		}
		return bool;
	};

	const linkComponent = (
		<div className={clsx(classesProp.root, 'flex items-center')}>
			<div>
				{tierCheck('stratus') ? (
					<EnterpriseLogo className={clsx(classes.logo, classesProp.logo)} />
				) : (
					<StarterLogo className={clsx(classes.logo, classesProp.logo)} />
				)}
			</div>
		</div>
	);

	return link ? (
		<Link to={pageSection.licenseGroupDomain ? '/' : pageSection.manager ? '/manager/tenants' : '/welcome'}>
			{linkComponent}
		</Link>
	) : (
		linkComponent
	);
};

export default Logo;
